/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import Wiggle from '../animations/wiggle';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.SynonymRolls.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.SynonymRolls, 22]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.SynonymRolls.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.round = 1;
  this.flyingBag = null;
  this.Rolls = [];
  this.dropZoneItems = [];
  this.errorBox = [];
  this.roundIndicator = null;
};

EDC.Games.SynonymRolls.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.SynonymRolls.Scenes.Main.prototype.constructor = EDC.Games.SynonymRolls.Scenes.Main;

const SR = EDC.Games.SynonymRolls.Scenes.Main.prototype;

SR.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

SR.createTemplateUI = function () {
  this.add.sprite(1110, 90, 'frame2').setOrigin(0);
  this.add.sprite(0, 163, 'frame1').setOrigin(0);
  this.flyingBag = this.add.sprite(1300, 235, 'bag').setOrigin(0);
  this.tweens.add({
    targets: this.flyingBag,
    y: this.flyingBag.y - 15,
    repeat: -1,
    yoyo: true,
  });
};

SR.loadIteration = function () {
  this.createRolls();
  this.generateWiggle();
};

SR.update = function () {
  for (let i = 0; i < this.dropZoneItems.length; i++) {
    this.dropZoneItems[i].x = 1500;
    if (i === 0) {
      this.dropZoneItems[i].y = this.flyingBag.y + 265;
    } else {
      this.dropZoneItems[i].y = this.flyingBag.y + 415;
    }
  }
};

SR.getRollPosition = function (i) {
  let x;
  let y;
  let s;
  if (this.gameConfig.sets[this.difficulty].iterations[this.iteration].words.length > 4) {
    x = 200 + 275 * i;
    y = 450;
    s = 0.7;
    if (i > 2) {
      x = 315 + 275 * (i % 3);
      y += 200;
    }
  } else {
    x = 255 + 400 * i;
    y = 450;
    s = 1;
    if (i > 1) {
      x = 255 + 400 * (i % 2);
      y += 250;
    }
  }
  return { x, y, s };
};

SR.createRolls = function () {
  const font = {
    font: '70px Arial',
    fill: 'white',
    textShadow: '10px 10px black;',
    align: 'center',
    padding: {
      left: 25,
      right: 0,
      top: 80,
      bottom: 0,
    },
    stroke: '#000',
    strokeThickness: 10,
  };
  const font2 = {
    font: '68px Arial',
    fill: 'white',
    textShadow: '10px 10px black;',
    align: 'center',
    padding: {
      left: 280,
      right: 0,
      top: 48,
      bottom: 42,
    },
    stroke: '#000',
    strokeThickness: 10,
  };
  this.roundIndicator = this.add.container(273, 80);
  const indicator = this.add.sprite(0, 0, 'round-indicator');
  const round = this.add.text(0, 0, this.round, font2).setOrigin(0.5);
  this.roundIndicator.add(indicator);
  this.roundIndicator.add(round);
  this.roundIndicator.setSize(491, 96);
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].words.length; i++) {
    const { x, y, s } = this.getRollPosition(i);
    const rollContainer = this.add.container(x, y);
    const word = this.gameConfig.sets[this.difficulty].iterations[this.iteration].words[i];
    const rndRoll = Math.floor(Math.random() * 3) + 1;
    const roll = this.add.sprite(0, 0, `roll-${rndRoll}`).setScale(s);
    const text = this.add
      .text(0, 0, word, font)
      .setOrigin(0.5, 0.5)
      .setScale(s);
    rollContainer.add([roll, text]);
    rollContainer.init_pos_x = x;
    rollContainer.init_pos_y = y;
    rollContainer.setSize(roll.width, roll.height);
    rollContainer.wordText = word;
    rollContainer.isIdle = true;
    rollContainer.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(rollContainer);
    this.input.setDraggable(rollContainer);

    rollContainer.wiggleAnim = new Wiggle(this, rollContainer);
    rollContainer.on(
      'drag',
      ((sprite, pointer, x, y) => {
        sprite.setPosition(x, y);
      }).bind(this, rollContainer),
    );
    rollContainer.on('dragend', this.onDragStop.bind(this, rollContainer), this);
    rollContainer.on('dragstart', this.onDragstart.bind(this, rollContainer), this);
    this.Rolls.push(rollContainer);
  }
};

SR.onDragStop = function (dragObj, pointer) {
  dragObj.isIdle = true;
  if (dragObj.x > 1150) {
    const slots = this.dropZoneItems.length;
    if (slots < 2) {
      this.dropZoneItems.push(dragObj);
    } else {
      dragObj.x = dragObj.init_pos_x;
      dragObj.y = dragObj.init_pos_y;
    }
  } else {
    for (let i = 0; i < this.dropZoneItems.length; i++) {
      if (dragObj.wordText === this.dropZoneItems[i].wordText) {
        if (i === 0) {
          this.dropZoneItems.shift();
          this.wiggleGroup.shift();
          if (this.dropZoneItems.length === 1) {
            this.dropZoneItems[i].y = 500;
            slots = 1;
          }
        } else {
          this.dropZoneItems.pop();
        }
      }
    }
    this.releaseRoll(dragObj);
  }
  if (this.dropZoneItems.length === 2) {
    this.checkAnswer();
  }
};

SR.onDragstart = function (dragObj, pointer) {
  dragObj.isIdle = false;
  dragObj.wiggleAnim.stop();
  for (let i = 0; i < this.dropZoneItems.length; i++) {
    if (dragObj.wordText === this.dropZoneItems[i].wordText) {
      if (i === 0) {
        this.dropZoneItems.shift();
        if (this.dropZoneItems.length === 1) {
          this.dropZoneItems[i].y = 500;
          slots = 1;
        }
      } else {
        this.dropZoneItems.pop();
      }
    }
  }
};

SR.nextIteration = function () {
  this.dropZoneItems = [];
  this.wiggleGroup = [];
  this.Rolls.map((rollContainer) => {
    rollContainer.destroy();
    return true;
  });
  this.Rolls = [];
  this.roundIndicator.destroy();
  this.roundIndicator = null;
  this.roundLevel = this.roundLevel + 1;
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

SR.checkAnswer = function () {
  const { correct } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const correctAnswers = this.dropZoneItems.filter(x => correct.includes(x.wordText));
  if (correctAnswers.length === 2) {
    this.playCorrect();
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    this.playWrong();
    this.wrongBox();
    for (let i = 0; i < this.dropZoneItems.length; i++) {
      this.dropZoneItems[i].first.setTint(0xff0000);
    }
    this.time.delayedCall(2000, this.errorAnimation, [], this);
  }
};

SR.releaseRoll = function (dragObj) {
  this.tweens.add({
    targets: dragObj,
    x: dragObj.init_pos_x,
    y: dragObj.init_pos_y,
    duration: 600,
    ease: 'Quint.easeOut',
  });
};

SR.errorAnimation = function () {
  this.errorBox.map((x) => {
    x.destroy();
    return true;
  });
  for (let i = 0; i < this.dropZoneItems.length; i++) {
    this.releaseRoll(this.dropZoneItems[i]);
    this.dropZoneItems[i].first.clearTint();
  }
  this.dropZoneItems = [];
};

SR.wrongBox = function () {
  const cont = this.add.container(1050, 400);
  const bgwrong = this.add.graphics(1050, 400);
  bgwrong.lineStyle(10, 0xff0000, 1);
  bgwrong.fillStyle(0x000000, 0.4);
  bgwrong.fillRoundedRect(-300, -150, 600, 300, 50);
  bgwrong.strokeRoundedRect(-300, -150, 600, 300, 50);
  cont.add(bgwrong);
  const text = this.add.text(0, 0, 'WRONG!', {
    fontFamily: 'Arial',
    fontStyle: 'bold',
    fontSize: '76px',
    fill: 'white',
    align: 'center',
  });
  text.setOrigin(0.5);
  bgwrong.setScale(0.8, 0.8);
  cont.add(text);
  text.setScale(1.2);
  this.errorBox.push(cont);
};

SR.generateWiggle = function (delayTime) {
  this.time.addEvent({ delay: delayTime || 6000, callback: this.startWiggle, callbackScope: this });
};

SR.startWiggle = function () {
  for (let i = 0; i < this.Rolls.length; i++) {
    if (this.Rolls[i].x < 1150 && this.Rolls[i].isIdle) {
      this.Rolls[i].wiggleAnim.start();
    }
  }
  this.generateWiggle(8000);
};
export default EDC.Games.SynonymRolls.Scenes.Main;
